export class UIStateModel {
  showTutorial: boolean = false;
  showDiscardModal: boolean = false;
  isModalOpen: boolean = false;
  showLocationInfo: boolean = false;
  showDesignList: boolean = false;
  showMagnetPopup: boolean = false;
  selectedMagnetImage: string = '';
  isPopupAnimating: boolean = false;
  isPopupClosing: boolean = false;

  reset(): void {
    this.showTutorial = false;
    this.showDiscardModal = false;
    this.isModalOpen = false;
    this.showLocationInfo = false;
    this.showDesignList = false;
    this.showMagnetPopup = false;
    this.selectedMagnetImage = '';
    this.isPopupAnimating = false;
    this.isPopupClosing = false;
  }

  openDiscardModal(): void {
    this.showDiscardModal = true;
    this.isModalOpen = true;
  }

  closeDiscardModal(): void {
    this.showDiscardModal = false;
    this.isModalOpen = false;
  }

  toggleDesignList(): void {
    this.showDesignList = !this.showDesignList;
  }
}

